import React from "react";
import SalesPriceList from "./SalesPriceList";

const SalesPriceManagement = () => {
    return (
        <div>
            <SalesPriceList />
        </div>
    );
};

export default SalesPriceManagement; 